var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"skipLink",class:_vm.templateClass,attrs:{"tabindex":"-1"}},[_c('main-header'),_vm._v(" "),_c('div',{staticClass:"residentportal-default"},[_c('div',{staticClass:"container"},[_c('router-view',{staticClass:"residentportal-form"})],1)]),_vm._v(" "),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }